export const isAttachmentNameValid = (name: string) => {
  return name && name.length <= 100;
};
